module.exports = __webpack_public_path__ + "img/alarm_black.66e69a6c.svg";